<template>
  <div class="app-header" >
    <div class="header-content">
        <div class="headlerlogotitle" @click="imgClick()" @mouseenter="zoneType = false">
          <el-image style="width: 100%;height: 56px" :src="require('@@/assets/images/header/logo.png')"></el-image>
        </div>
      <div class="header-elMenu">
        <el-menu mode="horizontal" :default-active="current" class="headmenu" active-text-color="#F18C1D" text-color="#333333" @select="handleSelect">
          <template v-for="item in menuItems">
            <el-menu-item v-if="!item.children || !item.children.length" :key="item.location" :index="item.location" style="height: 30px">
              <a v-if="item.location === '/zone'"  @mouseenter="handleMouseEnter"  >{{ item.label }}</a>
              <a v-else :href="item.location" @mouseenter="zoneType = false" @click.prevent >{{ item.label }}</a>
              <div v-if="current === item.location" style="margin: 4px 15px 0 15px ;height: 4px;background: #F8901F;"></div>
            </el-menu-item>
            <el-submenu v-else :key="item.location" :index="item.location">
              <template slot="title"><span >{{ item.label }}</span></template>
              <el-menu-item v-for="child in item.children" :key="child.location" style="height: 30px">
                <a :href="child.location" @click.prevent>{{ child.label }}</a>
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
      <div v-if="zoneType" class="zone"  @mouseleave="zoneType = false" >
        <div style="display: flex;justify-content: left;align-items: center;flex-wrap: wrap">
          <div v-for="(item,index) in specialZoneList" style="" :key="item.id">
            <div class="zoneId" style="width: 180px;height: 64px;margin-bottom: 16px;" :style="(index+1)%4 === 0 ? '' : 'margin-right: 20px'" @click="specialZoneClick(item)">
              <Picture style="width: 100%;height: 100%" :file-id="item.navigationLogo"></Picture>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {getRegionYzApi} from "@/api/api";
import Picture from "@/components/picture/picture.vue";
export default {
  components:{Picture},
  data() {
    return {
      showbox: true,
      usertype: "0",
      topath: "",
      current: "/home",
      islogin: false,//是否已登陆
      menuItems: [
        {label: "首页", location: "/home",},
        {label: "交易信息", location: "/about",},
        {label: "业主采购专区", location: "/zone",},
        {label: "保函系统", location: "/guarantee",},
        {label: "开评标室预约", location: "/bidEvaluationOffice",},
        {label: "帮助中心", location: "/download",},
        {label: "平台专家库", location: "/myExpert",},
        {label: "关于我们", location: "/ourself",},
      ],
      specialZoneList:[],
      zoneType:false
    };
  },
  created() {
    let menu = sessionStorage.getItem("menu");
    this.current = menu ? (menu == "/" ? "/home" : menu) : "/home";
  },
  mounted() {
    this.getRegionYz()
  },
  methods: {
    // 顶部导航跳转
    handleSelect(path) {
      this.toPage(path);
    },
    // 页面跳转
    toPage(path, val) {
      if(path === '/zone') return
      if (path === '/guarantee') window.open('guarantee/')
      if (path === '/bidEvaluationOffice') window.open('/bidEvaluationOffice/')
      this.$router.push({path: path, query: {type: val}});
    },
    imgClick(){
      this.$router.push({path: "/home",});
    },
    async getRegionYz(){
      const {data} = await getRegionYzApi()
      this.specialZoneList =  data
    },
    handleMouseEnter() {
      this.zoneType = !this.zoneType
      console.log('鼠标移入');
    },
    handleMouseLeave() {
      this.zoneType = !this.zoneType
    },
    specialZoneClick(val){
      let routeData = this.$router.resolve({path: "/zone/homeZone", query: {zoneId:val.id}});
      window.open(routeData.href, '_blank');
    },
  },
  watch: {
    '$route': {
      immediate: true,
      handler(n) {
          this.$nextTick(() => this.current = n.path)
      }
    }
  }
};
</script>
<style scoped lang="less">
.app-header{
  margin: 0;
  padding: 0;
  width: 100%;
  height: 80px;

}
.header-content{
  max-width: 1360px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  position:relative ;

}
.headlerlogotitle {
  width: 185px;
  color:#F8901F;
  font-weight: bold;
  display: flex;
  justify-content: right;
  align-items: center;
}
.header-elMenu{
 width: calc(100% - 399px);
}
 ::v-deep .el-menu{
   width: 100% ;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
  ::v-deep .el-menu-item {
    padding: 0 3px;
    height: 30px;
    margin: 0 10px;
    font-size: 20px;
  }
::v-deep .el-menu.el-menu--horizontal {
    border-bottom: none;
  }
  & > div {
    height: inherit;
    align-items: center;
  }

::v-deep .el-menu--horizontal > .el-menu-item.is-active {
  //border-bottom: 4px solid#F8901F;
  border: none;
}
::v-deep .el-menu--horizontal>.el-menu-item{
  line-height: 30px;
}
.zone{
  width: 812px;
  height: 272px;
  background: #FFFFFF;
  padding: 20px 32px;
  position: absolute;
  right: 0;
  top: 80px;
  z-index: 999;
}
.zoneId{
  border: 1px solid #DCDCDC;
  &:hover{
    border-radius: 2px 2px 2px 2px;
    border: 2px solid #D57F22;
  }
}
</style>
